export default __webpack_public_path__ + "static/media/announcement_4@3x.c6bde4d6.png";